import React from "react";
import styles from "./Newspaper.module.scss";
import news1 from "../../../../img/news1.svg";
import news3 from '../../../../img/news3.webp'
import news4 from "../../../../img/news4.webp";
import news2 from "../../../../img/news2.webp";
import { useTranslation } from "react-i18next";

const Newspaper = () => {
  const { t } = useTranslation();

  return (
    <section className={styles.newspaper}>
      <div className="container">
        <div className={styles.newspaper__title}>{t("Known from")}</div>
        <div className={styles.newspaper__wrapper}>
          <a
            href="https://www.bild.de/regional/mecklenburg-vorpommern/mecklenburg-vorpommern-news/kiff-ahoi-an-der-ostsee-firma-plant-deutschlands-groesste-cannabis-farm-87283146.bild.html"
            target="_blank"
            rel="noreferrer"
          >
            <picture>
              <source srcSet={news2} type="image/webp" />
              <img src={news2} alt="news" />
            </picture>
          </a>
          <a
            href="https://www.ndr.de/nachrichten/mecklenburg-vorpommern/Anklam-Erste-Cannabisfarm-in-MV-entsteht,cannabisfarm100.html"
            target="_blank"
            rel="noreferrer"
          >
            <picture>
              <source srcSet={news3} type="image/webp" />
              <img src={news3} alt="news" />
            </picture>
          </a>
          <a
            href="https://www.tagesschau.de/inland/regional/mecklenburgvorpommern/ndr-anklam-erste-cannabisfarm-in-mv-entsteht-100.html"
            target="_blank"
            rel="noreferrer"
          >
            <picture>
              <source srcSet={news4} type="image/webp" />
              <img src={news4} alt="news" />
            </picture>
          </a>
          <a
            href="https://www.hamburg-news.hamburg/standort/cannabis-legalisierung-ein-genussmarkt-der-sich-rechnet"
            target="_blank"
            rel="noreferrer"
          >
            <picture>
              <source srcSet={news1} type="image/svg+xml" />
              <img src={news1} alt="news" />
            </picture>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Newspaper;
